import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";

/** Only rendered for an unlocked type: a locked section sells the upgrade through its banner instead. */
export const IntentSignalTypeSectionAction = () => {
    const { translate } = useTranslate();

    const handleManageClick = (): void => {
        void intentTrackingService.trackManageTopicsAction();
        void siNavigator.goToIntentSignalsManagementPage();
    };

    return (
        <Button
            type="primary"
            dataAutomation="account-signals-intent-section-manage-button"
            onClick={handleManageClick}
        >
            {translate("si.intent.management.btn.manage-topics")}
        </Button>
    );
};
